module.exports = __webpack_public_path__ + "ec68a58f3f2f4768b4659b5c76db22bb.svg";